// AGC: DroidFarm - App Entry Point
import React from 'react'
import ReactDOM from 'react-dom/client'
import { Toaster } from 'react-hot-toast'
// AGC: QueryOnlyProvider until blockchain wallets are used (avoids wallet injector timeout in console)
import { QueryOnlyProvider } from '@droidfarm/shared'
import App from './App'
import '../styles/globals.css'

// AGC: Initialize i18n (must be imported before App)
import './i18n'
import { TranslationProvider, ThemeProvider } from './context'
import { unlockAudioContext } from './services/feedbackService'
import { initAnalytics } from './lib/analytics-init'

// AGC: One-time pointerdown unlocks AudioContext for iOS/Safari so first button click can play sound
document.addEventListener(
  'pointerdown',
  () => {
    unlockAudioContext()
  },
  { once: true }
)

// AGC: Polyfill for crypto.randomUUID if not available
if (typeof crypto !== 'undefined' && !crypto.randomUUID) {
  crypto.randomUUID = function randomUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0
      const v = c === 'x' ? r : (r & 0x3 | 0x8)
      return v.toString(16)
    })
  }
}

// AGC: Analytics runs fire-and-forget; don't block render on it
void initAnalytics()

// AGC: Get root element
const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('AGC: Root element not found - check index.html')
}

// AGC: Render app with providers
// AGC: ThemeProvider is the outermost provider for theme context
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ThemeProvider defaultTheme="light">
      <QueryOnlyProvider>
        <TranslationProvider>
          <App />
          {/* AGC: Toast notifications using Droid Farm design system */}
          <Toaster
            position="top-center"
            toastOptions={{
              duration: 3000,
              style: {
                background: '#1F2937',
                color: '#F9FAFB',
                borderRadius: '12px', // AGC: rounded-droid
                padding: '12px 16px',
              },
              success: {
                iconTheme: {
                  primary: '#46b179', // AGC: droid-500
                  secondary: '#F9FAFB',
                },
              },
              error: {
                iconTheme: {
                  primary: '#EF4444',
                  secondary: '#F9FAFB',
                },
              },
            }}
          />
        </TranslationProvider>
      </QueryOnlyProvider>
    </ThemeProvider>
  </React.StrictMode>
)



